
const PUBLIC_KEY =  `pk_test_cD1gIBptwIBFuzEaIBXSuLvJ`
const GITHUB_USERNAME = `AndyFake`
const GITHUB_PASSWORD = `thinktank1!`

module.exports={PUBLIC_KEY,GITHUB_USERNAME,GITHUB_PASSWORD}


// WEBPACK FOOTER //
// ./src/PUBLIC_KEY.js